import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { TRANSLATE_PREFIX } from '../../consts';
import { getPostbackEventTypeLabelKey } from '../../utils';
import css from './OverwriteConfirmBody.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.POSTBACK_TEMPLATES_TAB`;
const PLATFORM_LABEL_PREFIX = `${TRANSLATE_PREFIX}.CAMPAIGN_TYPES.PLATFORM_OPTIONS`;

const OverwriteConfirmBody = ({ report, translate }) => (
    <div className={css.overwriteBody}>
        {report.length > 0 && (
            <div
                className={css.filterReport}
                role="region"
                aria-label={translate(`${TAB_PREFIX}.CONFIRM_DIALOG.FILTERED_MACROS_INTRO`)}
            >
                <span className={css.filterIntro}>
                    <Translate id={`${TAB_PREFIX}.CONFIRM_DIALOG.FILTERED_MACROS_INTRO`} />
                </span>
                {report.map(({ target, filtered }) => (
                    <div key={target.value} className={css.filterTargetGroup}>
                        <div className={css.filterTargetLabel}>{target.label}</div>
                        <ul className={css.filterMacroList}>
                            {filtered.map(({ macro, reason }) => (
                                <li key={macro}>
                                    <code>{macro}</code>
                                    {' - '}
                                    <span className={css.filterReason}>
                                        <Translate
                                            id={`${TAB_PREFIX}.CONFIRM_DIALOG.FILTERED_REASON_${reason}`}
                                            data={{
                                                platform: translate(
                                                    `${PLATFORM_LABEL_PREFIX}.${target.platform.toUpperCase()}`
                                                ),
                                                eventType: translate(
                                                    getPostbackEventTypeLabelKey(target.eventType, target.platform)
                                                ),
                                            }}
                                        />
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        )}
        <p>
            <Translate id={`${TAB_PREFIX}.CONFIRM_DIALOG.OVERWRITE_TEMPLATE_TEXT`} />
        </p>
    </div>
);

OverwriteConfirmBody.propTypes = {
    report: PropTypes.arrayOf(
        PropTypes.shape({
            target: PropTypes.shape({
                value: PropTypes.string.isRequired,
                label: PropTypes.string.isRequired,
                eventType: PropTypes.string.isRequired,
                platform: PropTypes.string.isRequired,
            }).isRequired,
            filtered: PropTypes.arrayOf(
                PropTypes.shape({
                    macro: PropTypes.string.isRequired,
                    reason: PropTypes.string.isRequired,
                }).isRequired
            ).isRequired,
        }).isRequired
    ).isRequired,
    translate: PropTypes.func.isRequired,
};

export default OverwriteConfirmBody;
